<template>
  <div>
      <h1>Leave</h1>
  </div>
</template>


<script>
  import { mapGetters, mapState } from "vuex";
  import axios from "axios";


  export default {
    components: {
    },
    name: "leaveEmailPage",
    data() {
      return {
          id: '',
          status: '',
      };
    },
    methods: {
      
    },
    computed: {
      ...mapGetters(["isAuthenticated", "authStatus", "getProfile"]),
      ...mapState({
        adminAccess: state => state.user.profile.adminAccess,
      }),
    },
    mounted() {
        const { leaveId, status, userId } = this.$route.query
        console.log(typeof(leaveId), status, userId);
        axios({
        method: "POST", 
        headers: {
            'Content-Type': 'application/json'
        },
        url: process.env.VUE_APP_API_PATH + "leaves/leaveUpdate/" + JSON.parse(leaveId) + "?status=" + status ,
        data: { 'approved': status, 'userId': userId, leave: {id: JSON.parse(leaveId)} },
      }).then((result) => {
        console.log(result);
      }),
        (error) => {
          console.error(error);
        };
    }
  };


</script>
